<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-07-03 13:45:05
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-07-22 10:30:56
 * @FilePath: /wemeet-admin-new/src/views/data/components/noData.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-row style="width: 100%">
    <el-col
      :lg="24"
      :md="24"
      :sm="24"
      style="display: flex; align-items: center; justify-content: center; flex-direction: column"
      :xl="24"
      :xs="24"
    >
      <img
        alt=""
        src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/im/imNoData.png"
        style="width: 300px; height: 200px"
      />
      <div style="margin-top: 20px; color: #333; font-size: 16px; font-weight: bold">暂无数据</div>
    </el-col>
  </el-row>
</template>

<script>
  import { defineComponent, reactive, toRefs, watch } from 'vue'
  import _ from 'lodash'
  import VabChart from '@/extra/VabChart'
  import VabCount from '@/extra/VabCount'

  export default defineComponent({
    components: {
      VabChart,
      VabCount,
    },

    setup(props) {},
  })
</script>

<style lang="scss" scoped>
  .dialogCard {
    width: 100%;
    min-height: 174px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    padding: 20px;
    box-sizing: border-box;
    .subBox {
      .title {
        font-weight: 500;
        font-size: 16px;
        color: #1d2129;
        margin-bottom: 4px;
      }
      .subTitle {
        font-size: 12px;
        color: #4e5969;
      }
    }

    .ul {
      margin-top: 15px;
      .smTitle {
        font-size: 16px;
        color: #1d2129;
      }
    }
  }
</style>
